import React, { useEffect, useState } from "react";
import RestService from "./../../Restservice";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Link, useParams } from "react-router-dom";
import Divider from "@material-ui/core/Divider";
import Loader from "./../../component/Loader";
import BanService from "./BanService";
import PMSFORM from "../enquiryForm/PMS";
import ExpertAdv from "../enquiryForm/ExpertAdv";
import GlobalHelmet from "../../GlobalHelmet";
import Common from "./../../common.json";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  tabcolor: {
    backgroundColor: "#007bff",
  },
  disabledLink: {
    backgroundColor: "hsl(0, 0%, 95%)",
    borderColor: "hsl(0, 0%, 90%)",
  },
}));

export default function PremiumServicesList() {
  const classes = useStyles();
  let userParams = useParams();
  const typeValue = userParams?.slug ? 2 : 0;
  const [value, setValue] = React.useState(typeValue);
  const [loading, setLoading] = useState(false);
  const [showType, setShowType] = useState(0);
  const [globalData, SetGlobalData] = useState(false);

  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  const mobile = userdata.mobile ? userdata.mobile : "";
  const web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getServiceDetails(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setShowType(response.data.showType);
        SetGlobalData(response.data);
      },
      mobile,
      web_token
    );
  }, [mobile, web_token]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div className="bodycontainer">
      {loading ? <Loader /> : ""}
      <GlobalHelmet {...Common?.premiumServices} />
      <div className="auto-space">
        <div className="signalheader">
          <div className={classes.root}>
            <AppBar position="static" className="">
              <Tabs
                className={classes.tabcolor + " service-tab"}
                value={value}
                onChange={handleChange}
                aria-label="simple tabs example"
              >
                <Tab label="Pro +" {...a11yProps(0)} />
                <Tab label="Portfolio Analysis" {...a11yProps(1)} />
                <Tab label="F&O" {...a11yProps(2)} />
                <Tab label="Expert Advisory" {...a11yProps(3)} />
                <Tab label="PMS" {...a11yProps(4)} />
              </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
              <div className="row">
                <div className="col-lg-3">
                  <List>
                    <ListItem button>
                      <Link to="/watchlist">
                        <ListItemText primary="Watchlist" />
                      </Link>
                    </ListItem>
                    <Divider />

                    <ListItem button>
                      <Link to="/nse-sectors-list">
                        <ListItemText primary="Sector" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <Link to="/portfolio">
                        <ListItemText primary="My Portfolio" />
                      </Link>
                    </ListItem>
                    {/* <Divider />
                    <ListItem button>
                      <Link to="/piotroski-scan">
                        <ListItemText primary="Piotroski Scan" />
                      </Link>
                    </ListItem> */}
                  </List>

                  <h3>Screener</h3>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page7) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page7) === 1 ? (
                        <Link to="/autosignal">
                          <ListItemText primary="Autosignal (Live)" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Autosignal  (Live)" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page8) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page8) === 1 ? (
                        <Link to="/screener">
                          <ListItemText primary="Screener EOD" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Screener EOD" />
                        </>
                      )}
                    </ListItem>
                    <Divider />

                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page29) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page29) === 1 ? (
                        <Link to="/intraday-screener">
                          <ListItemText primary="Customize Screener" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Customize Screener" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/fundamental-analysis">
                        <ListItemText primary="Fundamental Screener" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/technical-analysis">
                        <ListItemText primary="Indicators Screener" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/preMarket-screener">
                        <ListItemText primary="Pre Market Screener" />
                      </Link>
                    </ListItem>
                  </List>

                  <h3>Tips</h3>
                  <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/free-stock-tips/">
                        <ListItemText primary="Free Stock Tips" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page9) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page9) === 1 ? (
                        <Link to="/premimum-stock-tips/">
                          <ListItemText primary="Premium Stock Tips" />
                        </Link>
                      ) : (
                        <BanService title="Premium Stock Tips" />
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page10) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page10) === 1 ? (
                        <Link to="/nifty-stock-tips/">
                          <ListItemText primary="Nifty Tips" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Nifty Tips" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page11) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page11) === 1 ? (
                        <Link to="/robo-free-stock-tips/">
                          <ListItemText primary="Robo Free Stocks" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Robo Free Stocks" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page12) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page12) === 1 ? (
                        <Link to="/robo-premium-stock-tips/">
                          <ListItemText primary="Robo Premium Stocks" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Robo Premium Stocks" />
                        </>
                      )}
                    </ListItem>
                  </List>
                </div>

                <div className="col-lg-3">
                  <h3>Market</h3>
                  <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/market">
                        <ListItemText primary="Indices" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/global-market">
                        <ListItemText primary="Global Market" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/nse-sectors-list/">
                        <ListItemText primary="Sectors" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/important-link">
                        <ListItemText primary="Important Links" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/commodity">
                        <ListItemText primary="Commodity" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page13) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page13) === 1 ? (
                        <Link to="/commodity-signal">
                          <ListItemText primary="Commodity Signal" />
                        </Link>
                      ) : (
                        <BanService title="Commodity Signal" />
                      )}
                    </ListItem>
                  </List>
                  <h3>Price Pattern</h3>
                  <List component="div" disablePadding>
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/cash/">
                        <ListItemText primary="Cash" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/future-stock/">
                        <ListItemText primary="Future Stock" />
                      </Link>
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <Link to="/nse-option-chain-data/">
                        <ListItemText primary="Market Activity" />
                      </Link>
                    </ListItem>
                  </List>
                </div>
                <div className="col-lg-3">
                  <h3>Screener EOD</h3>
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page14) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page14) === 1 ? (
                        <Link to="/special-screener">
                          <ListItemText primary="Quick Screener" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Quick Screener" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page15) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page15) === 1 ? (
                        <Link to="/stratergy">
                          <ListItemText primary="My Strategies" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="My Strategies" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page16) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page16) === 1 ? (
                        <Link to="/back-testing">
                          <ListItemText primary="Back Test" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Back Test" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page17) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page17) === 1 ? (
                        <Link to="/stock-idea">
                          <ListItemText primary="Stock Ideas" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Stock Ideas" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page18) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page18) === 1 ? (
                        <Link to="/signal-alert">
                          <ListItemText primary="Signal Alert" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Signal Alert" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page19) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page19) === 1 ? (
                        <Link to="/support-and-target">
                          <ListItemText primary="Support & Targets" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Support & Targets" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page20) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page20) === 1 ? (
                        <Link to="/trading-tools">
                          <ListItemText primary="Trading Tools" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Trading Tools" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page21) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page21) === 1 ? (
                        <Link to="/nse-pre-market">
                          <ListItemText primary="Pre market" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Pre market" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page22) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page22) === 1 ? (
                        <Link to="/open-interest-analysis">
                          <ListItemText primary="Open Interest Analysis" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Open Interest Analysis" />
                        </>
                      )}
                    </ListItem>
                  </List>
                </div>
                <div className="col-lg-3">
                  <List>
                    <h3> &nbsp;</h3>
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page23) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page23) === 1 ? (
                        <Link to="/watchlist-signal/">
                          <ListItemText primary="Watchlist Signal" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Watchlist Signal" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page24) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page24) === 1 ? (
                        <Link to="/market-breadth-today">
                          <ListItemText primary="Market Breadth" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Market Breadth" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page25) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page25) === 1 ? (
                        <Link to="/sector-analysis">
                          <ListItemText primary="Sector Analysis" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Sector Analysis" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page26) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page26) === 1 ? (
                        <Link to="/market-signal">
                          <ListItemText primary="NIfty Signal" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="NIfty Signal" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page27) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page27) === 1 ? (
                        <Link to="/chart-and-price">
                          <ListItemText primary="Chart & Levels" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Chart & Levels" />
                        </>
                      )}
                    </ListItem>
                    <Divider />
                    <ListItem button className={classes.nested}>
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      <ListItemText primary="Partner Program" />
                    </ListItem>
                    <Divider />
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page28) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {showType !== 0 ||
                      parseInt(globalData?.pageStatus?.page7) === 28 ? (
                        <Link to="/hourly-gainer-looser">
                          <ListItemText primary="Hourly Gainer Loser" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Hourly Gainer Loser" />
                        </>
                      )}
                    </ListItem>
                  </List>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div className="row">
                <div className="col-lg-3">
                  <List component="div" disablePadding>
                    <ListItem
                      button
                      className={
                        showType === 0 &&
                        parseInt(globalData?.pageStatus?.page7) === 0
                          ? classes.disabledLink
                          : classes.nested
                      }
                    >
                      <i className="fa fa-arrow-right"></i> &nbsp;
                      {globalData?.portfolioAnalysis > 0 ? (
                        <Link to="/portfolio-analysis">
                          <ListItemText primary="Portfolio Analysis" />
                        </Link>
                      ) : (
                        <>
                          <BanService title="Portfolio Analysis" />
                        </>
                      )}
                    </ListItem>
                  </List>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Link
                to="/nse-option-chain-data/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Chain" />
              </Link>
              <Link
                to="/option-chain/analysis/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Analysis" />
              </Link>
              <Link
                to="/option-chain/option-tips/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Tips" />
              </Link>
              <Link
                to="/option-chain/live-option-tips/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Live Tips" />
              </Link>
              <Link
                to="/option-data-historical/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Data Historical" />
              </Link>
              <Link
                to="/option-dashboard/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Dashboard" />
              </Link>
              <Link
                to="/futures-and-options/"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Future Dashboard" />
              </Link>
              <Link
                to="/option-chain/highest-oi-history"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Highest OI Call/Put History" />
              </Link>
              <Link
                to="/option-chain/option-trading-terminal"
                className="btn btn-success mt-2  mr-2"
              >
                <ListItemText primary="Option Trading Terminal " />
              </Link>
              <Link
                to="/option-chain/support-and-target"
                className="btn btn-success mt-2 mr-2"
              >
                <ListItemText primary="Support And Target" />
              </Link>
              <Link
                to="/option-chain/option-strategy"
                className="btn btn-success mt-2 mr-2"
              >
                <ListItemText primary="Option Strategy" />
              </Link>
              <Link to="/option-screener" className="btn btn-success mt-2 mr-2">
                <ListItemText primary="Option Screener" />
              </Link>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <ExpertAdv />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <PMSFORM />
            </TabPanel>
          </div>
        </div>
      </div>
    </div>
  );
}
